import { Plugin, PluginState } from 'editor/src/store/plugins/types';

const showPremiumPrompt = (plugin: Plugin) =>
  plugin.state === PluginState.ENABLED || plugin.state === PluginState.NON_FUNCTIONAL
    ? plugin.extra?.gelatoPlusPrompt
    : undefined;

export default showPremiumPrompt;
